// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"105":"75bc04c9","176":"12da57c4","501":"7fc01ece","977":"b1f68e2f"}[chunkId] + ".chunk.js";
};